import { Redirect, Slot } from 'expo-router';
import { Platform, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import EonOneMobile from '@/components/eon-one/mobile';
import { isDesktop, useHasOrganization } from '@/core';
import { Loader } from '@/ui/loader';

export default function EonOneLayout() {
  useStyles();

  const isNative = Platform.OS !== 'web';
  const { canUseEonOne, isPending } = useHasOrganization();

  if (isNative || !isDesktop()) {
    return <EonOneMobile />;
  }

  if (isPending) {
    return (
      <View
        style={{
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loader style={{ height: 250, width: 250 }} />
      </View>
    );
  }

  if (!canUseEonOne) {
    return <Redirect href="/partner/join-eon-one" />;
  }

  return <Slot />;
}
